/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AiUsageCompanyLimitModel } from '../../models/ai-usage-company-limit-model';

export interface SaveCompanyLimit$Params {
      body?: AiUsageCompanyLimitModel
}

export function SaveCompanyLimit(http: HttpClient, rootUrl: string, params?: SaveCompanyLimit$Params, context?: HttpContext): Observable<StrictHttpResponse<AiUsageCompanyLimitModel>> {
  const rb = new RequestBuilder(rootUrl, SaveCompanyLimit.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AiUsageCompanyLimitModel>;
    })
  );
}

SaveCompanyLimit.PATH = '/api/AIUsage/SaveCompanyLimit';
